// Parent route for /squad/* — pass-through; children own UI.
import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/squad')({
  component: () => <Outlet />,
})
